import { IWorkOrderGridRow } from 'Data/ReduxViewModels/Ags/WorkOrderGrid/types';
import React from 'react';
import { useSelector } from 'react-redux';
import { WorkOrderListItem } from './../WorkOrderListItem';

const WorkOrderList: React.FC = () => {
  const stateData = useSelector((state) => state.agsWorkOrderList);
  let workOrderGridData: IWorkOrderGridRow[] = stateData.gridData;

  return (
    <ul>
      {workOrderGridData.map((d, i) => (
        <WorkOrderListItem key={`${i}`} rowData={d} />
      ))}
    </ul>
  );
};

export { WorkOrderList };
export default WorkOrderList;
